import { render, staticRenderFns } from "./CourseAdd.vue?vue&type=template&id=9fcaad10&scoped=true&"
import script from "./CourseAdd.vue?vue&type=script&lang=js&"
export * from "./CourseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcaad10",
  null
  
)

export default component.exports